import cookie from "./cookie";

export default {
  // 验证有没有权限
  verifyAuthority(powers) {
    // console.log(localStorage.getItem("power"))
    if (powers) {
      let isExistsPower = false;
      let user = JSON.parse(cookie.getCookie("user"));

      // 角色id为1是系统管理员账号、不检测权限 不为1则需要检查权限
      if (user.roleId == 1) {
        isExistsPower = true;
      } else {
        let menuAttrs = JSON.parse(localStorage.getItem("power"));
        for (var i = 0; i < powers.length; i++) {
          for (let k in menuAttrs) {
            if (k === powers[i]) {
              // 因为设置的第0个都是查看权限，所以这里可以直接取第0个，不用循环
              if (menuAttrs[k][0].exists) {
                isExistsPower = true;
                break; // 只要有查看权限就可以展示，这里不用判断其他权限
              }
            }
          }
          if (isExistsPower) {
            break;
          }
        }
      }
      return isExistsPower;
    } else {
      return false;
    }
  },

  currentPower(key) {
    let powers = {};
    let user = JSON.parse(cookie.getCookie("user"));
    let menuAttrs = JSON.parse(localStorage.getItem("power"));
    for (let k in menuAttrs) {
      if (k === key) {
        let attr = menuAttrs[k];
        for (var i = 0; i < attr.length; i++) {
          // 角色id为1是系统管理员账号、不检测权限 不为1则需要检查权限
          if (user.roleId == 1) {
            powers[attr[i].actionName] = true;
          } else {
            powers[attr[i].actionName] = attr[i].exists
              ? attr[i].exists
              : false;
          }
        }
        break;
      }
    }
    return powers;
  },

  currentBatchs(batchs, power) {
    let powerList = [];
    let user = JSON.parse(cookie.getCookie("user"));
    // 角色id为1是系统管理员账号、不检测权限 不为1则需要检查权限
    if (user.roleId == 1) {
      powerList = batchs;
    } else {
      for (var i = 0; i < batchs.length; i++) {
        let batchs_name = JSON.parse(JSON.stringify(batchs[i].text));
        if (batchs_name === "显示" || batchs_name === "隐藏") {
          batchs_name = "显示/隐藏";
        } else if (
          batchs_name == "免审发布" ||
          batchs_name == "提交审核" ||
          batchs_name == "撤销" ||
          batchs_name == "撤销审核" ||
          batchs_name == "撤稿"
        ) {
          batchs_name = "提交审核/撤销审核/驳回原因";
        }
        if (power.hasOwnProperty(batchs_name)) {
          if (power[batchs_name]) {
            // 当这个权限值为true时
            powerList.push(batchs[i]);
          }
        } else {
          powerList.push(batchs[i]);
        }
      }
    }
    return powerList;
  },

  getQuery(params) {
    var query = JSON.parse(JSON.stringify(params));
    for (var k in query) {
      if (!query[k] || query[k].length <= 0) {
        delete query[k];
      }
    }
    let is_q = false;
    if (query.q) {
      for (var j in query.q) {
        if (!query.q[j] || query.q[j].length <= 0) {
          delete query.q[j];
        } else {
          is_q = true;
        }
      }
    }
    if (!is_q) {
      delete query.q;
    }
    return query;
  },

  verification(power_key) {
    let isPower = false;
    let user = JSON.parse(cookie.getCookie("user"));
    // 角色id为1是系统管理员账号、不检测权限 不为1则需要检查权限
    if (user.roleId == 1) {
      isPower = true;
    } else {
      let power = JSON.parse(localStorage.getItem("power"));
      for (var i = 0; i < power.length; i++) {
        if (power[i].key == power_key) {
          isPower = true;
        }
      }
    }
    return isPower;
  },

  // 获取链接参数
  getQueryString(data, name) {
    var reg = new RegExp("(^|&?)" + name + "=([^&]*)(&|$)", "i");
    var r = data.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },

  // 字符串格式转时间
  getDate(strDate) {
    var date = eval(
      "new Date(" +
        strDate
          .replace(/\d+(?=-[^-]+$)/, function(a) {
            return parseInt(a, 10) - 1;
          })
          .match(/\d+/g) +
        ")"
    );
    return date;
  },

  // 时间戳转成日期
  getTimeStamp(time) {
    let date = new Date(time * 1000);
    //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? "0" + MM : MM; //月补0
    let d = date.getDate();
    d = d < 10 ? "0" + d : d; //天补0
    let h = date.getHours(); //小时
    h = h < 10 ? "0" + h : h; //小时补0
    let m = date.getMinutes(); //分钟
    m = m < 10 ? "0" + m : m; //分钟补0
    let s = date.getSeconds(); //秒
    s = s < 10 ? "0" + s : s; //分钟补0
    return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
  },

  // 二维码
  getQRcode(clientUrl) {
    // 生成一个隐藏元素记录二维码
    var qrcodeDiv = document.createElement("div");
    qrcodeDiv.id = "app-rqcode";
    qrcodeDiv.style.position = "absolute";
    qrcodeDiv.style.top = "-999px";
    qrcodeDiv.style.left = "-999px";
    document.getElementById("app").appendChild(qrcodeDiv);

    // 生成二维码
    var qrcode = new QRCode(document.getElementById("app-rqcode"), {
      text: clientUrl,
      width: 200,
      height: 200,
      correctLevel: QRCode.CorrectLevel.H,
    });
    var canvas_data = {};
    canvas_data.title = clientUrl;
    // 获取二维码的链接
    var canvas_code = document.getElementById("app-rqcode").firstElementChild;
    canvas_data.url = canvas_code.toDataURL();
    qrcodeDiv.parentNode.removeChild(qrcodeDiv); //删除元素避免污染
    return canvas_data;
  },

  /**
   * 大数字转换，将大额数字转换为万、千万、亿等
   * @param value 数字值
   */
  bigNumberTransform(value) {
    const newValue = ["", "", ""];
    let fr = 1000;
    let num = 3;
    let text1 = "";
    let fm = 1;
    while (value / fr >= 1) {
      fr *= 10;
      num += 1;
      // console.log('数字', value / fr, 'num:', num)
    }
    if (num <= 4) {
      // 千
      newValue[0] = parseInt(value / 1000) + "";
      newValue[1] = "千";
    } else if (num <= 8) {
      // 万
      text1 = parseInt(num - 4) / 3 > 1 ? "千万" : "万";
      // tslint:disable-next-line:no-shadowed-variable
      fm = text1 === "万" ? 10000 : 10000000;
      if (value % fm === 0) {
        newValue[0] = parseInt(value / fm) + "";
      } else {
        newValue[0] = parseFloat(value / fm).toFixed(2) + "";
      }
      newValue[1] = text1;
    } else if (num <= 16) {
      // 亿
      text1 = (num - 8) / 3 > 1 ? "千亿" : "亿";
      text1 = (num - 8) / 4 > 1 ? "万亿" : text1;
      text1 = (num - 8) / 7 > 1 ? "千万亿" : text1;
      // tslint:disable-next-line:no-shadowed-variable
      fm = 1;
      if (text1 === "亿") {
        fm = 100000000;
      } else if (text1 === "千亿") {
        fm = 100000000000;
      } else if (text1 === "万亿") {
        fm = 1000000000000;
      } else if (text1 === "千万亿") {
        fm = 1000000000000000;
      }
      if (value % fm === 0) {
        newValue[0] = parseInt(value / fm) + "";
      } else {
        newValue[0] = parseFloat(value / fm).toFixed(2) + "";
      }
      newValue[1] = text1;
    }
    if (value < 1000) {
      newValue[0] = value + "";
      newValue[1] = "";
    }
    return newValue.join("");
  },

  // 距离今天多少天
  getBeforeDate(n) {
    var now = new Date();
    var aftertime = new Date(n);
    var year = now.getFullYear();
    var mon = now.getMonth() + 1;
    var day = now.getDate();
    var year_after = aftertime.getFullYear();
    var mon_after = aftertime.getMonth() + 1;
    var day_after = aftertime.getDate();
    var chs = 0;
    //获取当月的天数
    function DayNumOfMonth(Year, Month) {
      return 32 - new Date(Year, Month - 1, 32).getDate();
    }
    if (aftertime.getTime() - now.getTime() < 0) {
      var temp1 = day_after;
      var temp2 = mon_after;
      var temp3 = year_after;
      day_after = day;
      mon_after = mon;
      year_after = year;
      day = temp1;
      mon = temp2;
      year = temp3;
    }
    if (year == year_after) {
      //不跨年
      if (mon == mon_after) {
        //不跨年不跨月
        chs += day_after - day;
      } else {
        //不跨年跨月
        chs += DayNumOfMonth(year, mon) - day + 1; //加上第一个不满的
        for (var i = 1; i < mon_after - mon; i++) {
          chs += DayNumOfMonth(year, mon + i);
        }
        chs += day_after - 1; //加上
      }
    } else {
      //存在跨年
      chs += DayNumOfMonth(year, mon) - day + 1; //加上开始年份不满的一个月
      for (var m = 1; m < 12 - mon; m++) {
        chs += DayNumOfMonth(year, mon + m);
      }
      for (var j = 1; j < year_after - year; j++) {
        if (
          (year + j) % 400 == 0 ||
          ((year + j) % 4 == 0 && (year + j) % 100 != 0)
        ) {
          chs += 366;
        } else {
          chs += 365;
        }
      }
      for (var n = 1; n <= mon_after; n++) {
        chs += DayNumOfMonth(year_after, n);
      }
      chs += day_after - 1;
    }
    if (aftertime.getTime() - now.getTime() < 0) {
      return -chs;
    } else {
      return chs;
    }
  },

  getTodayTime() {
    var date = new Date();
    var year = date.getFullYear(); //年 ,从 Date 对象以四位数字返回年份
    var month = date.getMonth() + 1; //月 ,从 Date 对象返回月份 (0 ~ 11) ,date.getMonth()比实际月份少 1 个月
    var day = date.getDate(); //日 ,从 Date 对象返回一个月中的某一天 (1 ~ 31)
    var hours = date.getHours(); //小时 ,返回 Date 对象的小时 (0 ~ 23)
    var minutes = date.getMinutes(); //分钟 ,返回 Date 对象的分钟 (0 ~ 59)
    var seconds = date.getSeconds(); //秒 ,返回 Date 对象的秒数 (0 ~ 59)
    //修改月份格式
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    //修改日期格式
    if (day >= 0 && day <= 9) {
      day = "0" + day;
    }
    //修改小时格式
    if (hours >= 0 && hours <= 9) {
      hours = "0" + hours;
    }
    //修改分钟格式
    if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes;
    }
    //修改秒格式
    if (seconds >= 0 && seconds <= 9) {
      seconds = "0" + seconds;
    }
    //获取当前系统时间  格式(yyyy-mm-dd hh:mm:ss)
    var currentFormatDate =
      year +
      "-" +
      month +
      "-" +
      day +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds;
    return currentFormatDate;
  },

  differenceDate(num) {
    var date1 = new Date();
    var time1 =
      date1.getFullYear() + "-" + date1.getMonth() + "-" + date1.getDate();
    var date2 = new Date(date1);
    date2.setDate(date1.getDate() + num);
    var time2 =
      date2.getFullYear() + "-" + date2.getMonth() + "-" + date2.getDate();
    return time2;
  },

  rangeDate() {
    let frontDate = this.differenceDate(-8);
    frontDate = frontDate.split("-");
    let behindDate = this.differenceDate(7);
    behindDate = behindDate.split("-");
    return (time) => {
      return (
        time.getTime() >
          new Date(behindDate[0], behindDate[1], behindDate[2]) ||
        time.getTime() < new Date(frontDate[0], frontDate[1], frontDate[2])
      );
    };
  },

  getVideoCover(url) {
    return new Promise(function(resolve) {
      let dataURL = "";
      let video = document.createElement("video");
      video.setAttribute("crossOrigin", "anonymous"); //处理跨域
      video.setAttribute("src", url);
      video.setAttribute("width", 400);
      video.setAttribute("height", 400);
      video.setAttribute("autoplay", "autoplay");
      video.addEventListener("canplaythrough", function() {
        let canvas = document.createElement("canvas"),
          width = video.width, //canvas的尺寸和图片一样
          height = video.height;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
        dataURL = canvas.toDataURL("image/jpeg"); //转换为base64
        resolve(dataURL);
      });
    });
  },

  /**
   * 清理前后空格
   * @param {String} str
   * @returns {String}
   */
  clearSpace(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },

  /**
   * 判断编辑器内容数据
   * @param {String} str
   * @returns {String}
   */
  checkEditorIsNull(domStr) {
    const placeholder = document.createElement("div");
    placeholder.innerHTML = domStr;
    const getAllNode = (node, nodeArr = []) => {
      node.childNodes.forEach((item) => {
        nodeArr.push(item);
      });
      for (const childNode of node.childNodes) {
        if (childNode.childNodes.length > 0) {
          getAllNode(childNode, nodeArr);
        }
      }
    };
    const allNodes = [];
    getAllNode(placeholder, allNodes);
    let content = "";
    allNodes.forEach((node) => {
      if (node.tagName) {
        if (node.tagName.toLowerCase() == "img") {
          content = content + "img";
        }
        if (node.innerText) {
          content = content + node.innerText;
        }
      }
    });
    placeholder.remove();
    return Boolean(this.clearSpace(content).length);
  },

  //数字转中文
  toChinesNum(num) {
    let changeNum = [
      "零",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六",
      "七",
      "八",
      "九",
    ];
    let unit = ["", "十", "百", "千", "万"];
    num = parseInt(num);
    let getWan = (temp) => {
      let strArr = temp
        .toString()
        .split("")
        .reverse();
      let newNum = "";
      let newArr = [];
      strArr.forEach((item, index) => {
        newArr.unshift(
          item === "0" ? changeNum[item] : changeNum[item] + unit[index]
        );
      });
      let numArr = [];
      newArr.forEach((m, n) => {
        if (m !== "零") numArr.push(n);
      });
      if (newArr.length > 1) {
        newArr.forEach((m, n) => {
          if (newArr[newArr.length - 1] === "零") {
            if (n <= numArr[numArr.length - 1]) {
              newNum += m;
            }
          } else {
            newNum += m;
          }
        });
      } else {
        newNum = newArr[0];
      }
      return newNum;
    };
    let overWan = Math.floor(num / 10000);
    let noWan = num % 10000;
    if (noWan.toString().length < 4) {
      noWan = "0" + noWan;
    }
    return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
  },

  // getVideoCover(videoUrl){
  // 	console.log(videoUrl)
  // 	var videoElement = document.createElement("video");
  // 	videoElement.id = 'app-video-cover'
  // 	videoElement.style.position = 'absolute'
  // 	videoElement.style.top = '-999px'
  // 	videoElement.style.left = '-999px'
  // 	videoElement.autoplay = true
  // 	videoElement.src = videoUrl
  // 	document.getElementById("app").appendChild(videoElement);
  //     videoElement.addEventListener("loadeddata", function (_event) {
  // 		var canvas = document.createElement("canvas");
  // 		canvas.width = videoElement.videoWidth * 0.8;
  // 		canvas.height = videoElement.videoHeight * 0.8;
  // 		canvas.getContext('2d').drawImage(videoElement, 0, 0, canvas.width, canvas.height);
  // 		document.getElementById("app-video-cover").appendChild(canvas);
  // 		let coverUrl = canvas.toDataURL("image/png");
  // 		videoElement.parentNode.removeChild(videoElement); //删除元素避免污染
  // 		canvas.parentNode.removeChild(canvas); //删除元素避免污染
  // 		console.log(coverUrl)
  // 		return coverUrl
  // 	});
  // }

  // 缓存标签搜索记录
  cacheSearchTagName(tag) {
    if (tag) {
      let hotTagKeyword = localStorage.getItem("hotTagKeyword");
      if (!hotTagKeyword) {
        hotTagKeyword = [];
        hotTagKeyword.push(tag);
      } else {
        hotTagKeyword = JSON.parse(hotTagKeyword);
        let pos = -1;
        hotTagKeyword.forEach((hotTag, idx) => {
          if (tag.id === hotTag.id) {
            pos = idx;
          }
        });
        if (pos === -1) {
          if (hotTagKeyword.length >= 5) {
            hotTagKeyword.pop();
          }
        } else {
          hotTagKeyword.splice(pos, 1);
        }
        hotTagKeyword.unshift(tag);
      }
      localStorage.setItem("hotTagKeyword", JSON.stringify(hotTagKeyword));
    }
  },
  // 获取标签搜索记录缓存
  getSearchTagNameCache() {
    let hotTagKeyword = localStorage.getItem("hotTagKeyword");
    if (!hotTagKeyword) {
      hotTagKeyword = [];
    } else {
      hotTagKeyword = JSON.parse(hotTagKeyword);
    }

    return hotTagKeyword;
  },
  // 获取文件大小 size Num
  getFileSize(size) {
    const units = ["B", "KB", "MB", "GB", "TB"];
    let i = 0;
    while (size >= 1024 && i < units.length - 1) {
      size /= 1024;
      i++;
    }
    return size.toFixed(0) + " " + units[i];
  },
};
